/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IDlvryQuestbackViewProps } from './dlvry-questback';

export default (props: IDlvryQuestbackViewProps) => {
    const {
        popupId,
        popupClassName,
        modalContentClassName,
        modalContentCloseButton,
        questBackIFrame
    } = props;

    return (
        <div id={popupId} className={popupClassName}>
            <div className={modalContentClassName}>
                {modalContentCloseButton}
                {questBackIFrame}
            </div>
        </div>
    );
};
